import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const AuthPage: React.FC = () => {
  const { login, register } = useAuth();
  const [tab, setTab] = useState<'login' | 'register'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = async () => {
    setError('');
    setLoading(true);
    try {
      if (tab === 'login') await login(email, password);
      else await register(email, password, name);
    } catch (e: any) {
      // Le message est déjà traduit en français par AuthContext
      setError(e?.message || "Une erreur est survenue. Réessayez.");
    }
    setLoading(false);
  };

  const S = { box: { maxWidth: 420, margin: '0 auto', padding: '48px 32px' } as React.CSSProperties, input: { width: '100%', background: '#252540', border: '1px solid #3A3A5C', borderRadius: 12, padding: '14px 16px', color: '#F8F7FF', fontSize: 15, outline: 'none', marginBottom: 14, boxSizing: 'border-box' as const } };

  return (
    <div style={{ minHeight: '100vh', background: '#0A0A0F', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={S.box}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ fontSize: 32, fontWeight: 800, color: '#F8F7FF', marginBottom: 4 }}>Contenu<span style={{ color: '#6C47FF' }}>IA</span> <span style={{ color: '#00F5A0' }}>●</span></div>
          <div style={{ color: '#C8C8E8', fontSize: 14 }}>Transforme ton produit en contenu qui vend</div>
        </div>
        <div style={{ display: 'flex', gap: 4, background: '#1A1A2E', borderRadius: 12, padding: 4, marginBottom: 28 }}>
          {(['login', 'register'] as const).map(t => (
            <button key={t} onClick={() => setTab(t)} style={{ flex: 1, padding: 10, border: 'none', borderRadius: 10, cursor: 'pointer', fontSize: 14, fontWeight: 500, background: tab === t ? '#6C47FF' : 'transparent', color: tab === t ? '#FFF' : '#C8C8E8' }}>
              {t === 'login' ? 'Connexion' : 'Inscription'}
            </button>
          ))}
        </div>
        {tab === 'register' && <input style={S.input} placeholder="Nom complet" value={name} onChange={e => setName(e.target.value)} />}
        <input style={S.input} type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
        <input style={S.input} type="password" placeholder="Mot de passe" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handle()} />
        {error && (
          <div style={{ background: 'rgba(255,68,68,0.08)', border: '1px solid rgba(255,68,68,0.25)', borderRadius: 10, padding: '10px 14px', marginBottom: 14, color: '#FF9999', fontSize: 13, lineHeight: 1.5 }}>
            ⚠️ {error}
          </div>
        )}
        <button onClick={handle} disabled={loading} style={{ width: '100%', padding: 16, background: '#6C47FF', border: 'none', borderRadius: 14, color: '#FFF', fontSize: 16, fontWeight: 700, cursor: 'pointer', opacity: loading ? 0.6 : 1 }}>
          {loading ? '⏳...' : tab === 'login' ? 'Se connecter →' : 'Créer mon compte →'}
        </button>
      </div>
    </div>
  );
};

export default AuthPage;
